import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { IQualificationDef } from 'src/app/model/view/iqualification-def';
import { PAGE_NAMES } from 'src/app/service/ansokan-form-builder/application-names';
import { AnsokanFormGroupService } from 'src/app/service/ansokan-form-group/ansokan-form-group.service';
import { QualificationRepositoryService } from 'src/app/service/qualification/qualification-repository.service';

@Component({
    selector: 'app-other-qualification',
    styleUrls: ['./other-qualification.component.scss'],
    templateUrl: './other-qualification.component.html',
    standalone: false
})
export class OtherQualificationComponent implements OnInit {

  public availableQualifications: IQualificationDef[];
  public pageGroup: UntypedFormGroup;

  constructor(
    private service: AnsokanFormGroupService,
    private repository: QualificationRepositoryService,
  ) { }

  public ngOnInit() {
    // Set page group.
    this.pageGroup = this.service.get(PAGE_NAMES.OTHER_QUALIFICATION.KEY) as UntypedFormGroup;
    // Get available qualifications.
    this.availableQualifications = this.repository.other;
  }
}
